import { viewsetDuck } from '@/shared/ducks/viewsetDuck';

export const DEFAULT_STATE = {};

export const duck = viewsetDuck('bulkAddressGroups', '/mgmt/api/bulk-address-groups/');

export const useBulkAddressesDisableAPI = (uid) => {
    return duck.useAPI(`${uid}/disable-addresses/`, { suspense: false, forceEndSlash: true });
};

export const useBulkForwardErrorsToDefaultLocationApi = (uid) => {
    return duck.useAPI(`${uid}/set-default-shipping-location/`, { suspense: false, forceEndSlash: true });
};

export const { actionTypes, actions, reducer, useAPI } = duck;

export default duck;
